export default __webpack_public_path__ + "static/media/essentialWebsiteHero.4211c502.jpg";